// extracted by mini-css-extract-plugin
export default {"root":"VerticalSpace_root__A91yi"};